import { SVGProps } from 'react';

const Snail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 13a6 6 0 0 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0m-8 0a8 8 0 1 0 16 0M2 13a8 8 0 1 1 16 0m0 0V7a2 2 0 1 1 4 0v6c0 4.4-3.6 8-8 8H2M18 3l1.1 2.2M22 3l-1.1 2.2"
    />
  </svg>
);
export default Snail;
